import { media } from '@mnd-frontend/ui';
import styled from 'styled-components';

export const SectionHeaderGrid = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 30%);
  justify-content: space-between;
  gap: 1rem;
  align-items: end;
  padding: 1rem;

  width: 100%;

  > :last-child {
    text-align: right;
  }

  ${media.lessThan('tablet')} {
    grid-template-columns: 100%;
    grid-template-row: auto auto;
    align-items: start;

    > :last-child {
      text-align: left;
    }
  }
`;
